import React, { forwardRef } from 'react';
import JobPositionInsightsForm from './components/JobPositionInsightsForm';

const JobPositionInsights = forwardRef(function JobPositionInsights(
	{
		jobPosition,
		onSuccess,
		isEditing,
		onIsEditingChange,
		onSubmittingChange,
		onDirtyChange
	},
	ref
) {
	return (
		<div className="job-position-insights">
			<JobPositionInsightsForm
				ref={ref}
				data={jobPosition}
				onSuccess={onSuccess}
				isEditing={isEditing}
				onIsEditingChange={onIsEditingChange}
				onSubmittingChange={onSubmittingChange}
				onDirtyChange={onDirtyChange}
			/>
		</div>
	);
});

export default JobPositionInsights;
